import { toLower, snakeCase } from 'lodash';
import axios from 'axios';
import {
    axiosDelete,
    axiosGet,
    axiosPatch,
    headersAuth,
} from './axios.helpers';
import { showOrganization } from './organization';

const baseUrl = `${process.env.REACT_APP_API_URL}/v1`;

export const getSchedulers = async(pageNumber, pageSize) =>
    axiosGet(`/schedules?page[number]=${pageNumber + 1}&page[size]=${pageSize}`);

export const getScheduler = async(id, includeClinic) => {
    const suffix = includeClinic ? '?include=clinics' : '';

    return axiosGet(`/schedules/${id}${suffix}`);
};

export const getSchedulerByLink = async(link) => axiosGet(`/booking${link}`);

export const getSchedulersByOrganizationId = async(orgId) =>
    axiosGet(
        `/schedules?page[size]=100&page[number]=1&filter[organization]=${orgId}`,
    );

export const exportScheduler = async(id, startDate, endDate) => {
    return axiosGet(
        `/schedules/${id}/export?filter[start_date]=${startDate}&filter[end_date]=${endDate}&type=csv`,
    );
};

export const updateScheduler = async(id, scheduler) => {
    const { name, organizationId, showBirthDate, customField } = scheduler;

    await axiosPatch(`/schedules/${id}`, {
        name,
        organization_id: organizationId,
        show_birth_date: showBirthDate,
        custom_field: customField,
    });
};

export const createScheduler = async(scheduler) => {
    const { name, organizationId, showBirthDate, customField } = scheduler;

    const {
        data: {
            data: { short_name: orgShortName },
        },
    } = await showOrganization(organizationId);

    const formatName = snakeCase(toLower(name));
    const formatShortName = snakeCase(toLower(orgShortName));

    return axios.post(
        `${baseUrl}/schedules`, {
            data: {
                attributes: {
                    name,
                    link: `${formatShortName}/${formatName}`,
                    show_birth_date: showBirthDate,
                    slots: 20,
                    clinics_number: 20,
                    custom_field: customField,
                },
                relationships: {
                    organization: {
                        id: organizationId,
                    },
                },
            },
        },
        headersAuth(),
    );
};

export const deleteScheduler = async(id) => {
    await axiosDelete(`/schedules/${id}`);
};